import { defineAsyncComponent } from "vue";

export default Object.assign(
  {},
  defineAsyncComponent(() => import("./column-boolean.vue")),
  {
    Filter: defineAsyncComponent(() => import("./filter.vue")),
  },
);
